"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const react_1 = __importDefault(require("react"));
const lodash_noop_1 = __importDefault(require("lodash.noop"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const useSidebar_1 = require("../../hooks/useSidebar");
const CollapseItem_1 = require("../Menu/CollapseItem");
const SidebarContainer_1 = require("../../styled/SidebarContainer");
const Menu_1 = require("../../styled/Menu");
const createItem_1 = require("./createItem");
/** Renders a sidebar from a configuration object */
const Sidebar = ({ items, collapseLabel, testId = 'SIDEBAR', onCollapseChange = lodash_noop_1.default, ...props }) => {
    const { isSidebarCollapsed } = (0, useSidebar_1.useSidebar)();
    react_1.default.useEffect(() => {
        onCollapseChange(isSidebarCollapsed);
    }, [isSidebarCollapsed, onCollapseChange]);
    const menuItems = items
        .filter(item => !item.isFooter)
        .map((elem, index) => (0, createItem_1.createMenuItem)(elem, index, testId));
    const footerMenuItems = items
        .filter(item => item.isFooter)
        .map((elem, index) => (0, createItem_1.createMenuItem)(elem, index, testId));
    return (react_1.default.createElement(SidebarContainer_1.SidebarContainer, { collapsed: isSidebarCollapsed, ...(0, oxygen_config_1.getTestAttributes)(testId), ...props },
        react_1.default.createElement(Menu_1.Ul, { ...(0, oxygen_config_1.getTestAttributes)(`${testId}_TOP_MENU`) }, menuItems),
        collapseLabel ? (react_1.default.createElement(CollapseItem_1.CollapseItem, { ...(0, oxygen_config_1.getTestAttributes)(`${testId}_COLLAPSE_ITEM`), label: collapseLabel })) : null,
        footerMenuItems.length > 0 ? (react_1.default.createElement(Menu_1.Ul, { footer: true, ...(0, oxygen_config_1.getTestAttributes)(`${testId}_FOOTER_MENU`) }, footerMenuItems)) : null));
};
exports.Sidebar = Sidebar;
